module.exports = __webpack_public_path__ + "img/bandcamp.98877277.png";